import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import ReactJWPlayer from "react-jw-player";
import styles from "./styles/player.css.js";
import withStyles from "components/with-styles";
import { jwtPlayerScriptUrl } from "config/paths";

const Player = ({ classes, className, fileId, fileUrl }) => (
  <div className={cn(className, classes.player)}>
    <ReactJWPlayer
      className={classes.player_internal}
      customProps={{
        height: 420,
        width: "100%",
      }}
      playerId={`file-${fileId}-player`}
      playerScript={jwtPlayerScriptUrl}
      file={fileUrl}
    />
  </div>
);

Player.propTypes = {
  /**
   ** Clase adicional del componente
   **/
  className: PropTypes.string,
  /**
   ** Id del fichero
   **/
  fileId: PropTypes.string,
  /**
   ** Url del vídeo
   **/
  fileUrl: PropTypes.string.isRequired,
};

export default withStyles(styles)(Player);
